import { render } from "./MarkPaid.vue?vue&type=template&id=0a2efad6"
import script from "./MarkPaid.vue?vue&type=script&lang=js"
export * from "./MarkPaid.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__